//平台权限
export default [
    {
        path: 'platformPermissions',
        name: 'platformPermissions',
        meta: {
            title: '平台权限',
            icon: 'platformPermissions'
        },
        hidden: false,
        component: () => import("@/views/system/platformPermissions/index.vue"),
        children: [{
            path: 'menuManagement',
            name: 'menuManagement',
            meta: {
                title: '菜单管理',
                icon: 'menuManagement'
            },
            hidden: false,
            component: () => import("@/views/system/platformPermissions/menuManagement.vue"),
        },{
            path: 'roleManagement',
            name: 'roleManagement',
            meta: {
                title: '角色管理',
                icon: 'roleManagement'
            },
            hidden: false,
            component: () => import("@/views/system/platformPermissions/roleManagement.vue"),
        },{
            path: 'departmentManagement',
            name: 'departmentManagement',
            meta: {
                title: '部门管理',
                icon: 'departmentManagement'
            },
            hidden: false,
            component: () => import("@/views/system/platformPermissions/departmentManagement.vue"),
        },{
            path: 'accountManagement',
            name: 'accountManagement',
            meta: {
                title: '账号管理',
                icon: 'accountManagement'
            },
            hidden: false,
            component: () => import("@/views/system/platformPermissions/accountManagement.vue"),
        }]
    }

]